import { createContext, use, useState } from 'react'
import { Outlet, useRouterState } from '@tanstack/react-router'
import { AppShell } from './app-shell'
import { PareLoading } from '@/components/pare-loading'

export type PharmacyPage = {
  title: string
  mode: 'dashboard' | 'pos' | 'inventory' | 'construction'
}

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    pharmacy?: PharmacyPage
  }
}

const ShellSearchContext = createContext<{
  search: string
  setSearch: (value: string) => void
} | null>(null)

export function useShellSearch() {
  const context = use(ShellSearchContext)
  if (!context) throw new Error('Shell search requires the pharmacy shell')
  return context
}

export function ShellPending() {
  return <PareLoading label="กำลังโหลดหน้า…" />
}

export function PharmacyShell() {
  const route = useRouterState({
    select: (state) => state.matches.at(-1),
  })
  const pathname = route?.pathname ?? '/'
  const page = route?.staticData.pharmacy
  const [query, setQuery] = useState({ pathname, search: '' })
  // Reset before rendering the new page, including history navigation.
  if (query.pathname !== pathname) setQuery({ pathname, search: '' })
  const search = query.pathname === pathname ? query.search : ''
  const setSearch = (value: string) => setQuery({ pathname, search: value })

  return (
    <ShellSearchContext value={{ search, setSearch }}>
      <AppShell
        title={page?.title ?? 'Pare Pharmacy'}
        dashboard={{ search, onSearch: setSearch }}
        pos={page?.mode === 'pos'}
        inventory={page?.mode === 'inventory'}
        underConstruction={page?.mode === 'construction'}
        contentKey={`${pathname}:${route?.status ?? 'pending'}`}
      >
        <Outlet />
      </AppShell>
    </ShellSearchContext>
  )
}
